export default "/assets/site/images/MAVIRSE_logo.png?6679a333ba48542bae27ff0eca168c36";